module.exports = __webpack_public_path__ + "static/vinos_poligono-1-8cd2b45fa18cb54d962554573813fbce.jpg";